<template>
    <transition name="modal">
        <div class="modal__mask modalQuestionario" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container" :style="rowResponseModal">
                    <div class="content__modal">
                        <div class="inner__modal_questionario">
                            
                            <img class="modal__image" src="@/assets/questionario.png" />
                            <h2>Questionário Suitability</h2>
                            <form class="form__class" @submit.stop.prevent="createRepresentante">
                                <div class="row-question">
                                    <div class="form__controls">
                                        <label class="label__field">
                                            {{ questaoAtual?.Pergunta || 'Carregando pergunta...' }}
                                        </label>
                                    </div>
                                </div>
                                <div class="row-response" :class="{ 'scrollable': isScrollable }"
                                    v-if="questaoAtual?.Respostas && questaoAtual.Respostas[0] != null && questaoAtual.Respostas[0].Opcoes?.length == 0">
                                    <div class="row row-space-left" v-for="(resposta, index) in questaoAtual.Respostas"
                                        :key="index">
                                        <div class="form__controls">
                                            <div class="radio">
                                                <input v-if="questaoAtual.TipoResposta != 'Múltipla escolha'"
                                                    type="radio" :id="`${resposta.QuestionarioRespostaId}`"
                                                    :value="`${resposta.QuestionarioRespostaId}`" class="field__radio"
                                                    :name="`questionario`"
                                                    @click="salvarAlteracoesLocalmente(resposta.QuestionarioRespostaId, questaoAtual.QuestionarioId)" />
                                                <input
                                                    v-if="questaoAtual.TipoResposta == 'Múltipla escolha' && resposta.TipoResposta != 'Múltipla Escolha'"
                                                    type="checkbox" :id="`${resposta.QuestionarioRespostaId}`"
                                                    :value="`${resposta.QuestionarioRespostaId}`" class="field__radio"
                                                    :name="`questionario`"
                                                    @click="salvarAlteracoesLocalmente(resposta.QuestionarioRespostaId, questaoAtual.QuestionarioId)" />
                                                <input
                                                    v-if="questaoAtual.TipoResposta == 'Múltipla escolha' && resposta.TipoResposta == 'Múltipla Escolha'"
                                                    type="checkbox" :id="`${resposta.QuestionarioRespostaId}`"
                                                    :value="`${resposta.QuestionarioRespostaId}`" class="field__radio"
                                                    :name="`questionario`"
                                                    @click="salvarAlteracoesLocalmente(resposta.QuestionarioRespostaId, questaoAtual.QuestionarioId, 0, true)" />
                                                <label class="label__field" :for="`${resposta.QuestionarioRespostaId}`">
                                                    {{ resposta.Descricao }}
                                                </label>
                                            </div>
                                        </div>
                                        <div v-if="resposta.TipoResposta == 'Múltipla Escolha' && this.listaRespostasAtivas.findIndex(r =>
                                            r.QuestionarioRespostaId === resposta.QuestionarioRespostaId && r.QuestionarioId === questaoAtual.QuestionarioId) > -1"
                                            class="sub-resposta-container">
                                            <div class="row row-space-left"
                                                v-for="(subResposta, index) in resposta.Opcoes" :key="index">
                                                <div class="form__controls">
                                                    <div class="radio">
                                                        <input type="checkbox"
                                                            :id="`${subResposta.QuestionarioRespostaOpcaoId}`"
                                                            :value="`${subResposta.QuestionarioRespostaOpcaoId}`"
                                                            class="field__radio" :name="`questionario`"
                                                            @click="salvarAlteracoesLocalmente(resposta.QuestionarioRespostaId, questaoAtual.QuestionarioId, subResposta.QuestionarioRespostaOpcaoId)" />
                                                        <label class="label__field"
                                                            :for="`${subResposta.QuestionarioRespostaOpcaoId}`">
                                                            {{ subResposta.Resposta }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-response" :class="{ 'scrollable': isScrollable }"
                                    v-if="questaoAtual?.Respostas && questaoAtual.Respostas[0] != null && questaoAtual.Respostas[0].Opcoes?.length > 0">
                                    <table class="table-modal">
                                        <thead>
                                            <th style="width: 20%">Item</th>
                                            <th style="width: 15%">Tipo</th>
                                            <th style="width: 15%">Classificação</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(resposta, index) in questaoAtual.Respostas" :key="index">
                                                <td>{{ numeroQuestao + 1 }}.{{ index }}</td>
                                                <td>{{ resposta.Descricao }}</td>
                                                <td>
                                                    <select id="tipoCadastro"
                                                        @change="salvarAlteracoesLocalmente(resposta.QuestionarioRespostaId, questaoAtual.QuestionarioId, $event.target.value)"
                                                        class="field">
                                                        <option value="">Selecione</option>
                                                        <option v-for="item in resposta.Opcoes"
                                                            :key="item.QuestionarioRespostaOpcaoId"
                                                            :value="item.QuestionarioRespostaOpcaoId">
                                                            {{ item.Resposta }}
                                                        </option>
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div style="display: flex; flex-direction: row; justify-content: center; margin: 20px auto; gap: 20px;">
                                    <button class="btnDefaultQuestionario" type="button" @click="closeModal">
                                        Cancelar
                                    </button>
                                    <button v-if="questionario && (numeroQuestao + 1) < questionario.length"
                                        class="btnBlueQuestionario" type="button" @click="proximaQuestao()">
                                        Próximo
                                    </button>
                                    <button v-if="questionario && (numeroQuestao + 1) == questionario.length"
                                        class="btnBlueQuestionario" type="button" @click="concluirQuestionario()">
                                        Concluir
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';
import Cookies from 'js-cookie';

export default {
    computed: {
        isScrollable() {
            return true;
        },
        rowResponseQuestion() {
            if (!this.questaoAtual || !this.questaoAtual.Respostas) {
                return {
                    height: '140px'
                };
            }
            
            let totalHeight = 0;
            for (let resposta of this.questaoAtual.Respostas) {
                if (resposta?.Descricao) {
                    const characters = resposta.Descricao.length;
                    const increments = Math.ceil(characters / 60);
                    totalHeight += increments * 25; // Adiciona 50px à altura para cada incremento de 60 caracteres
                }
            }
            if (this.questaoAtual.Respostas == null || this.questaoAtual.Respostas.length == 0) {
                return {
                    height: 140 + 'px'
                };
            }
            if (this.questaoAtual.Respostas.length > 6) {
                return {
                    height: '100%'
                };
            }
            if (this.questaoAtual.Respostas.length > 0 && this.questaoAtual.Respostas[0]?.Opcoes?.length == 0) {
                let height = this.questaoAtual.Respostas.length * 30;
                if (totalHeight > height) {
                    height = totalHeight;
                }
                return {
                    height: height + 'px'
                };
            } else {
                const height = this.questaoAtual.Respostas.length * 130;
                return {
                    height: height + 'px'
                };
            }
        },
        rowResponseModal() {
            if (!this.questaoAtual) {
                return {
                    height: 400 + 'px'
                };
            }
            if (this.questaoAtual.Respostas == null) {
                return {
                    height: 400 + 'px'
                };
            }
            if (this.questaoAtual.Respostas.length < 5 && this.questaoAtual.Respostas.length > 0) {
                let totalHeight = 300;
                for (let resposta of this.questaoAtual.Respostas) {
                    if (resposta?.Descricao) {
                        const characters = resposta.Descricao.length;
                        const increments = Math.ceil(characters / 60);
                        totalHeight += increments * 25; // Adiciona 50px à altura para cada incremento de 60 caracteres
                    }
                }
                let heightRespostas = 300 + (this.questaoAtual.Respostas.length - 4) * 30;
                if (totalHeight > heightRespostas) {
                    heightRespostas = totalHeight;
                }
                return {
                    height: heightRespostas > 600 ? heightRespostas + 'px' : '600px'
                };
            }
            if (this.questaoAtual.Respostas.length > 6) {
                return {
                    height: '100%'
                };
            }
            if (this.questaoAtual.Respostas == null) {
                const height = 400;
                return {
                    height: height + 'px'
                };
            } else if (this.questaoAtual.Respostas[0]?.Opcoes?.length == 0 || this.questaoAtual.Respostas[0]?.Opcoes?.length == undefined) {
                let totalHeight = 0;
                for (let resposta of this.questaoAtual.Respostas) {
                    if (resposta?.Descricao) {
                        const characters = resposta.Descricao.length;
                        const increments = Math.ceil(characters / 60);
                        totalHeight += increments * 25; // Adiciona 50px à altura para cada incremento de 60 caracteres
                    }
                }
                let heightRespostas = (this.questaoAtual.Respostas.length - 4) * 30;
                if (totalHeight > heightRespostas) {
                    heightRespostas = totalHeight;
                }
                const height = 400 + (heightRespostas);
                return {
                    height: height + 'px'
                };
            } else {
                return {
                    height: '100%'
                };
            }
        },
        ...mapGetters({
            showModalCreate: "GET_MODAL_QUESTIONARIO",
            listaQuestoes: 'GET_MODAL_LISTAR_QUESTIONARIO',
            user: 'auth/user',
        }),
    },
    data() {
        return {
            rowResponseHeight: 0,
            questionario: [],
            questaoAtual: null,
            numeroQuestao: 0,
            respostaQuestionario: {
                ClienteId: 0,
                Respostas: []
            },
            listaRespostasAtivas: []
        }
    },
    mounted() {
        this.listaRespostasAtivas = [];
        this.$store.dispatch('FETCH_QUESTIONARIO_BUSCAR_QUESTOES');

        if(this.listaQuestoes != null){
            this.processarQuestoes();
        }
        
        this.respostaQuestionario.ClienteId = this.user.ClienteId;
    },
    watch: {
        listaQuestoes() {
            this.processarQuestoes();
        }
    },
    methods: {
        processarQuestoes(){
            if (this.listaQuestoes && this.listaQuestoes.length > 0) {
                // Filtra listaQuestoes para itens que correspondam ao TipoCliente do usuário
                const questoesFiltradas = this.listaQuestoes.filter(questao => questao.TipoCliente === this.user.TipoCliente);
                // Atualiza questionario e questaoAtual com as questões filtradas
                if (questoesFiltradas.length > 0) {
                    this.questionario = questoesFiltradas;
                    this.questaoAtual = questoesFiltradas[0];
                } else {
                    // Se nenhum item corresponder, você pode definir questionario e questaoAtual para valores padrão ou vazios
                    this.questionario = [];
                    this.questaoAtual = null; // ou {}, dependendo de como você quer lidar com "sem questões"
                }
            }
        },
        salvarAlteracoesLocalmente(QuestionarioRespostaId, QuestionarioId, OpcaoId = 0, habilitarSubResposta = false) {
            // Garantir que os IDs são números (para prevenir problemas de comparação de tipos)
            QuestionarioId = Number(QuestionarioId);
            QuestionarioRespostaId = Number(QuestionarioRespostaId);
            OpcaoId = Number(OpcaoId || 0);
            
            
            // Criar objeto de resposta com tipos corretos
            const novaResposta = {
                QuestionarioId: QuestionarioId,
                QuestionarioRespostaId: QuestionarioRespostaId,
                QuestionarioRespostaOpcaoId: OpcaoId
            };
            
            // RADIO BUTTONS (resposta única)
            if (this.questaoAtual.TipoResposta !== 'Múltipla escolha') {
                // 1. Criar um array temporário das respostas que queremos manter
                const respostasParaManter = this.respostaQuestionario.Respostas.filter(resposta => 
                    Number(resposta.QuestionarioId) !== QuestionarioId);
                    
                // 2. Adicionar explicitamente a nova resposta ao array temporário
                respostasParaManter.push(novaResposta);
                
                // 3. Substituir completamente o array original
                this.respostaQuestionario.Respostas = respostasParaManter;
                
                return; // IMPORTANTE: Sair da função aqui para radio buttons!
            }
            
            // CHECKBOXES (múltipla escolha)
            
            // Verificar se a resposta já existe (caso de desmarcação)
            let index = -1;
            if (habilitarSubResposta) {
                index = this.listaRespostasAtivas.findIndex(resposta =>
                    Number(resposta.QuestionarioRespostaId) === QuestionarioRespostaId && 
                    Number(resposta.QuestionarioId) === QuestionarioId && 
                    Number(resposta.QuestionarioRespostaOpcaoId) === OpcaoId);
            } else {
                index = this.respostaQuestionario.Respostas.findIndex(resposta =>
                    Number(resposta.QuestionarioRespostaId) === QuestionarioRespostaId && 
                    Number(resposta.QuestionarioId) === QuestionarioId && 
                    Number(resposta.QuestionarioRespostaOpcaoId) === OpcaoId);
            }
            
            // Se a resposta já existe, remover (desmarcação de checkbox)
            if (index !== -1) {
                if (habilitarSubResposta) {
                    this.listaRespostasAtivas.splice(index, 1);
                    
                    // Remover todas as sub-respostas relacionadas
                    let indexSubResposta = 0;
                    while (indexSubResposta >= 0) {
                        indexSubResposta = this.respostaQuestionario.Respostas.findIndex(resposta =>
                            Number(resposta.QuestionarioRespostaId) === QuestionarioRespostaId && 
                            Number(resposta.QuestionarioId) === QuestionarioId);
                        
                        if (indexSubResposta !== -1) {
                            this.respostaQuestionario.Respostas.splice(indexSubResposta, 1);
                        } else {
                            break; // Evitar loop infinito
                        }
                    }
                } else {
                    this.respostaQuestionario.Respostas.splice(index, 1);
                }
            } else {
                // Adicionar nova resposta (checkbox marcado)
                if (habilitarSubResposta) {
                    this.listaRespostasAtivas.push({ ...novaResposta });
                } else {
                    this.respostaQuestionario.Respostas.push({ ...novaResposta });
                }
            }
        
        },
        concluirQuestionario() {
            if (!this.capturarResposta()) {
                this.$swal({
                    icon: 'error',
                    title: 'Não preenchido',
                    text: `Necessário responder para avançar o questionário`,
                });
                return;
            }
            this.salvarFormulario();
        },
        capturarResposta() {
            // eslint-disable-next-line no-debugger
            debugger
            var indexUnico = this.respostaQuestionario.Respostas.findIndex(resposta =>
                resposta.QuestionarioId === this.questaoAtual.QuestionarioId);
            if (this.questaoAtual.Respostas[0]?.Opcoes?.length == 0 && indexUnico > -1) {
                return true;
            } else if (this.questaoAtual.Respostas[0]?.Opcoes?.length > 0) {
                const quantidade = this.respostaQuestionario.Respostas.filter(resposta =>
                    resposta.QuestionarioId === this.questaoAtual.QuestionarioId
                ).length;
                if (quantidade == this.questaoAtual.Respostas.length) {
                    return true;
                }
            }
            return false;
        },
        limparRespostas() {
            // eslint-disable-next-line no-debugger
            debugger
            this.questaoAtual.Respostas.forEach(resposta => {
                let inputElement = document.getElementById(resposta.QuestionarioRespostaId);
                if (inputElement) {
                    inputElement.checked = false;
                }
            });
        },
        proximaQuestao() {
            // eslint-disable-next-line no-debugger
            debugger
            if (!this.capturarResposta()) {
                this.$swal({
                    icon: 'error',
                    title: 'Não preenchido',
                    text: `Necessário responder para avançar o questionário`,
                });
                return;
            }
            this.limparRespostas();
            this.numeroQuestao++;
            this.questaoAtual = this.questionario[this.numeroQuestao];
        },
        closeModal() {
            this.questaoAtual = this.questionario[0];
            this.numeroQuestao = 0;
            this.respostaQuestionario.Respostas = [];
            this.listaRespostasAtivas = [];
            this.$store.commit("SET_MODAL_QUESTIONARIO", false);
            if(this.user.StatusCadastro == 3 && !this.user.PermiteLoginEmRevisao){
                this.$store.commit("SET_MODAL_CADASTRO_VENCIDO", true);
            }
        },
        logoff() {
            localStorage.removeItem('ClienteId');
            localStorage.removeItem('NomeRazaoSocial');
            localStorage.removeItem('Email');
            localStorage.removeItem('token');
            Cookies.remove('nomeUsuarioLogado');
            this.$router.push({ name: 'UserLogin' });
        },
        async salvarFormulario() {
            this.disableBtn = true;
             
            await api
                .post('/suitability', this.respostaQuestionario)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Formulário preenchido com sucesso!',
                            text: 'Dados informados foram salvos com sucesso.',
                        });
                        this.$store.dispatch('FETCH_PERFIL_CLIENTE', this.user.ClienteId);
                        this.closeModal();
                        if(this.user.StatusCadastro == 3 && !this.user.PermiteLoginEmRevisao)
                        {
                            this.logoff();
                        }else{
                            this.user.StatusCadastro = 4;
                        }
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        }
    },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');



// Classes reutilizáveis
.font-inter {
    font-family: 'Inter', sans-serif;
}

.font-weight-400 {
    font-weight: 400;
}

.font-weight-500 {
    font-weight: 500;
}

.font-weight-600 {
    font-weight: 600;
}

.border-default {
    border: 1px solid #D0D5DD;
}

.border-radius-8 {
    border-radius: 8px;
}

.padding-8 {
    padding: 8px;
}

.text-left {
    text-align: left;
}

.modal__image {
    width: 50px;
    height: 50px;
}

.scrollable {
    margin-left: 10px;
    max-height: 250px !important;
    overflow-y: scroll;
}

.modal__container {
    height: 600px !important;
    width: 550px;
    margin: 0 auto !important;
    position: relative !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start !important;
    align-items: center !important;

       @media (max-width: 768px) {
            width: calc(100% - 40px) !important;
            height: auto !important;
            padding: 0px !important;
            max-height: 75vh;
            border-radius: 16px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
            margin: 20px auto !important;
        }
}

.inner__modal_questionario {
    width: 450px;
    text-align: left;
    margin: 0 auto !important;
    
    @media (max-width: 768px) {
        width: 100% !important;
        margin: 0 auto !important;
        padding: 0 !important;
    }
}

.row-space-left {
    padding-left: 5px;
    text-align: left;
}

.row-question {
    margin-bottom: 10px;
    height: 100px;
    overflow-y: auto;
    
    @media (max-width: 768px) {
        height: auto !important;
        min-height: 80px !important;
        width: 100% !important;
    }
}

.row-response {
    margin-bottom: 10px;
    margin-left: 5px;
    height: 250px;
    text-align: left;
    
    @media (max-width: 768px) {
        margin-left: 0 !important;
        height: auto !important;
        max-height: 300px !important;
        width: 95% !important;
    }
}

.sub-resposta-container {
    margin-left: 20px;
    @extend .border-default;
    @extend .border-radius-8;
    width: 90%;
}

.btnBlueQuestionario, .btnDefaultQuestionario {
    height: 40px;
    @extend .font-inter;
    @extend .border-radius-8;
    width: 210px;
    cursor: pointer;
    
    @media (max-width: 768px) {
        width: 135px !important;
        min-width: 120px !important;
        margin: 0 5px !important;
    }
}

.btnBlueQuestionario {
    background-color: #00235C;
    color: white;
    border: 1px solid #00235C;
}

.btnDefaultQuestionario {
    background-color: white;
    color: #344054;
    @extend .border-default;
}

.table-modal {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.table-modal th, .table-modal td {
    @extend .border-default;
    @extend .padding-8;
    @extend .text-left;
    @extend .font-inter;
}

.table-modal th {
    background-color: #F9FAFB;
    @extend .font-weight-600;
}

.table-modal td {
    @extend .font-weight-400;
}

.label__field {
    @extend .font-inter;
    @extend .font-weight-500;
    font-size: 14px;
    line-height: 20px;
    color: #344054;
    display: block;
    margin-bottom: 8px;
    text-align: left;
}

.row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 0;
    justify-content: flex-start;
    text-align: left !important;
    width: 100% !important;
    margin-left: 0px !important;
}

.radio .label__field {
    margin-left: 8px;
    margin-bottom: 8px;
    margin-top: 0;
    text-align: left;
}

.field {
    width: 100%;
    padding: 10px;
    @extend .border-default;
    @extend .border-radius-8;
    background-color: #F9FAFB;
    @extend .font-inter;
    font-size: 14px;
    @extend .font-weight-500;
    line-height: 20px;
    color: #344054;
}



/* Alinhamento à esquerda */
.modalQuestionario {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    
    .modal__wrapper {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 100% !important;
        width: 100% !important;
    }
    
    .form__controls,
    .label__field,
    .row,
    .row-question,
    .row-response,
    .inner__modal_questionario,
    .label__field[for], 
    .form__class,
    .content__modal {
        text-align: left !important;
    }

    .modal__mask .row{
        margin-left: 10px !important;
    }


    .radio {
        display: flex !important;
        align-items: center !important;
        width: 100% !important;
        text-align: left !important;
        justify-content: flex-start !important;
    }

    .radio input {
        margin-right: 10px !important;
        position: relative !important;
        float: left !important;
    }

    .radio .label__field {
        text-align: left !important;
        width: calc(100% - 30px) !important;
        display: inline-block !important;
    }

    label {
        text-align: left !important;
    }
}
</style>